<template>
  <div>
    <SelectedCategoriesBubble
      :isAdminPage="isAdminPage"
      :subCategoryIds="this.competition.fundId.selectedSubCategories"
    />

    <p v-show="competition.fundId.productData.productDescription && showOnAdminPageOnly" class="mt-3">
      <b>Termék leírása: </b>
      {{ competition.fundId.productData.productDescription }}
    </p>

    <FundRequestTime
      title="Igénylési időszak"
      :requestStartDate="competition.fundId.appearanceDate.requestStartDate"
      :requestEndDate="competition.fundId.appearanceDate.requestEndDate"
      :availableUntilFundIsExhausted="competition.fundId.appearanceDate.availableUntilFundIsExhausted"
    />
    <FundRequestTime
      v-if="showOnAdminPageOnly"
      title="Megjelenési időszak"
      :requestStartDate="competition.fundId.appearanceDate.appearanceStartDate"
      :requestEndDate="competition.fundId.appearanceDate.appearanceEndDate"
    />

    <p v-show="competition.fundId.productData.linkToProduct && showOnAdminPageOnly" class="mt-3">
      <b>Link a termékhez: </b>
      <a :href="competition.fundId.productData.linkToProduct">{{ competition.fundId.productData.linkToProduct }}</a>
    </p>

    <p v-show="competition.fundId.creditData.creditServiceProvider" class="mt-3">
      <b>Szolgáltató:</b> {{ creditServiceProviderType[competition.fundId.creditData.creditServiceProvider] }}
    </p>
    <p
      v-show="
        (competition.fundId.creditData.creditMin || competition.fundId.creditData.creditMin === 0) &&
          competition.fundId.creditData.creditCurrency
      "
      class="mt-3"
    >
      <b>Igényelhető összeg minimuma:</b>
      {{ numberWithDots(competition.fundId.creditData.creditMin) }} {{ competition.fundId.creditData.creditCurrency }}
    </p>
    <p
      v-show="
        (competition.fundId.creditData.creditMax || competition.fundId.creditData.creditMax === 0) &&
          competition.fundId.creditData.creditCurrency
      "
      class="mt-3"
    >
      <b>Igényelhető összeg maximuma:</b>
      {{ numberWithDots(competition.fundId.creditData.creditMax) }} {{ competition.fundId.creditData.creditCurrency }}
    </p>
    <p v-show="competition.fundId.creditData.creditDescription" class="mt-3 mb-1">
      <b>Összeg megállapításának módja:</b>
      {{ competition.fundId.creditData.creditDescription }}
    </p>
    <p
      v-show="competition.fundId.creditData.selfContribution || competition.fundId.creditData.selfContribution === 0"
      class="mt-3 mb-1"
    >
      <b>Önerő:</b>
      {{ competition.fundId.creditData.selfContribution }}
    </p>
    <p v-show="competition.fundId.interest.interest" class="mt-3">
      <b>Kamat:</b> {{ competition.fundId.interest.interest }}
    </p>
    <p v-show="competition.fundId.interest.interestType" class="mt-3">
      <b>Kamat típusa:</b> {{ InterestType[competition.fundId.interest.interestType] }}
    </p>
    <p v-show="competition.fundId.creditData.creditMin || competition.fundId.creditData.creditMin === 0" class="mt-3">
      <b>Kamat minimuma:</b> {{ competition.fundId.creditData.creditMin }}
    </p>
    <p v-show="competition.fundId.creditData.creditMax || competition.fundId.creditData.creditMax === 0" class="mt-3">
      <b>Kamat maximuma:</b>
      {{ competition.fundId.creditData.creditMax }}
    </p>
    <p
      v-show="
        competition.fundId.intensityDuration.intensityAmount ||
          competition.fundId.intensityDuration.intensityAmount === 0
      "
      class="mt-3"
    >
      <b>Támogatási összeg megállapításának módja:</b>
      {{ competition.fundId.intensityDuration.intensityAmount }}
    </p>
    <p v-show="competition.fundId.interest.interestMin || competition.fundId.interest.interestMin === 0" class="mt-3">
      <b>Támogatás minimuma:</b> {{ numberWithDots(competition.fundId.interest.interestMin) }}
    </p>
    <p v-show="competition.fundId.interest.interestMax || competition.fundId.interest.interestMax === 0" class="mt-3">
      <b>Támogatás maximuma:</b>
      {{ numberWithDots(competition.fundId.interest.interestMax) }}
    </p>
    <p
      v-show="
        (competition.fundId.intensityDuration.intensityCredit ||
          competition.fundId.intensityDuration.intensityCredit === 0) &&
          (competition.fundId.intensityDuration.intensitySupportValue ||
            competition.fundId.intensityDuration.intensitySupportValue === 0)
      "
      class="mt-3"
    >
      <b>Hitel és vissza nem térítendő támogatás aránya:</b>
      {{ competition.fundId.intensityDuration.intensityCredit + '%' }} -
      {{ competition.fundId.intensityDuration.intensitySupportValue + '%' }}
    </p>
    <p
      v-show="
        competition.fundId.intensityDuration.repaymentMin || competition.fundId.intensityDuration.repaymentMin === 0
      "
      class="mt-3"
    >
      <b>Futamidő minimuma:</b>
      {{
        competition.fundId.intensityDuration.repaymentMin +
          ' ' +
          RepaymentType[competition.fundId.intensityDuration.repaymentType]
      }}
    </p>
    <p
      v-show="
        competition.fundId.intensityDuration.repaymentMax || competition.fundId.intensityDuration.repaymentMax === 0
      "
      class="mt-3"
    >
      <b>Futamidő maximuma:</b>
      {{
        competition.fundId.intensityDuration.repaymentMax +
          ' ' +
          RepaymentType[competition.fundId.intensityDuration.repaymentType]
      }}
    </p>
    <p v-show="competition.fundId.interest.repaymentRate" class="mt-3 mb-1">
      <b>Törlesztés üteme:</b>

      {{ competition.fundId.interest.repaymentRate }}
    </p>
    <p v-show="competition.fundId.interest.rateOfInterestRate" class="mt-3 mb-1">
      <b>Kamatfizetés üteme:</b>
      {{ competition.fundId.interest.rateOfInterestRate }}
    </p>
    <p
      v-show="
        competition.fundId.intensityDuration.availabilityTimeValue ||
          competition.fundId.intensityDuration.availabilityTimeValue === 0
      "
      class="mt-3"
    >
      <b>Rendelkezésre tartási idő:</b>
      {{
        competition.fundId.intensityDuration.availabilityTimeValue +
          ' ' +
          RepaymentType[competition.fundId.intensityDuration.availabilityTimeType]
      }}
    </p>
    <p
      v-show="
        competition.fundId.intensityDuration.gracePeriodValue ||
          competition.fundId.intensityDuration.gracePeriodValue === 0
      "
      class="mt-3"
    >
      <b>Türelmi idő:</b>
      {{
        competition.fundId.intensityDuration.gracePeriodValue +
          ' ' +
          RepaymentType[competition.fundId.intensityDuration.gracePeriodType]
      }}
    </p>
    <p v-show="competition.fundId.guarantee.guaranteeDescription" class="mt-3 mb-1">
      <b>Biztosítékok, hitelgarancia:</b>
      {{ competition.fundId.guarantee.guaranteeDescription }}
    </p>
    <p v-show="competition.fundId.guarantee.supportCondition" class="mt-3 mb-1">
      <b>Támogatás feltételei:</b>
      {{ competition.fundId.guarantee.supportCondition }}
    </p>
    <p v-show="competition.fundId.guarantee.performanceMeasurement" class="mt-3 mb-1">
      <b>Eredményességi mérés, átfordulás feltételei:</b>
      {{ competition.fundId.guarantee.performanceMeasurement }}
    </p>
    <div v-show="competition.fundId.guarantee.uniqueConditions.length > 0" class="mt-3">
      <b
        v-if="
          competition.fundId.guarantee.uniqueConditions[0] &&
            competition.fundId.guarantee.uniqueConditions[0].condition.length > 0
        "
        >Egyedi feltételek, kizárások:</b
      >
      <p class="mt-1" v-for="item in competition.fundId.guarantee.uniqueConditions" :key="item.id">
        {{ item.condition }}
      </p>
    </div>
  </div>
</template>

<script>
import FundRequestTime from '../../../../components/FundRequestTime.vue'
import { creditServiceProviderType, CreditType } from '../../../../enums/CreditType'
import InterestType from '../../../../enums/InterestType'
import RepaymentType from '../../../../enums/RepaymentType'
import SelectedCategoriesBubble from './SelectedCategoriesBubble.vue'

export default {
  props: {
    competition: { type: Object, required: true }
  },
  data() {
    return {
      CreditType,
      InterestType,
      RepaymentType,
      creditServiceProviderType,
      isAdminPage: false
    }
  },
  computed: {
    showOnAdminPageOnly() {
      return this.$route.path.includes('/competitions/details')
    }
  },
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    formatDate: function(date) {
      if (!date) {
        return 'N/A'
      }
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    }
  },
  components: { FundRequestTime, SelectedCategoriesBubble },
  created() {
    if (this.$route.path.includes('fund-map')) {
      this.isAdminPage = false
    } else {
      this.isAdminPage = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
